// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1O8C2","center":"App_center__O277T","downloaderWrap":"App_downloaderWrap__2ccpR"};